import React, { useState} from 'react'
import { withRouter } from 'react-router-dom';
import intl from '../../../../i18n/intl'
import {Avatar, Box, Card, InlineStack, OptionList,Text,Icon} from '@shopify/polaris';
import { useEffect } from 'react';
import utils from '../../../../utils/utils'
import { connect ,useSelector} from "react-redux";
import {
  StoreIcon,
  MoneyFilledIcon,
  PaymentFilledIcon,
  NotificationFilledIcon,
  LanguageFilledIcon
} from '@shopify/polaris-icons';

const PageContent = (props) => {
  var selected = props.selected;
  const [selecteds, setSelecteds] = useState(['']);
  const listArray = [
    {
      id: 1,
      value: '/admin/settings/general',
      label: <InlineStack gap="200">
        <Icon source={StoreIcon} tone="base"/>
        {intl.get("General")}
      </InlineStack>,
      matches: 'General',
    },
    {
      id: 2,
      value: '/admin/settings/price',
      label: <InlineStack gap="200">
      <Icon source={MoneyFilledIcon} tone="base"/>
      {intl.get("Smart price setting")}
    </InlineStack>,
      matches: 'Smart price setting'
    },
    {
      id: 3,
      value: '/admin/settings/payment',
      label: <InlineStack gap="200">
      <Icon source={PaymentFilledIcon} tone="base"/>
      {intl.get("Auto Payment")}
    </InlineStack>,
      matches: 'Payment',
      img:'/sub/sub_head_light.png'
    },
    {
      id: 4,
      value: '/admin/settings/notification',
      label: <InlineStack gap="200">
      <Icon source={NotificationFilledIcon} tone="base"/>
      {intl.get("Notification")}
    </InlineStack>,
      matches: 'Notification'
    },
    {
      id: 5,
      value: '/admin/settings/language',
      label: <InlineStack gap="200">
      <Icon source={LanguageFilledIcon} tone="base"/>
      {intl.get("Language")}
    </InlineStack>,
      matches: 'Language',
    }
  ]
  let userInfo = useSelector(state => state.languageReducer.subScriptData);
  const shopify = window.shopify;
  
  useEffect(() => {
    let isMount = false;
    if (!isMount) {  
      for (let i = 0; i < listArray.length; i++) {
        if (listArray[i].matches === selected) {
          setSelecteds(listArray[i].value)
        }
      }
    }
    return () => {
      isMount = true
    };
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selected]);
 
  const onChangeSelected = (selected) => {
    if (shopify){
    if (!props.disabled) {
      shopify.saveBar.leaveConfirmation()
      return;
    }
  }
  const { pathname } = window.location;
  if (!pathname.includes(selected[0])) {// 判断是否跳转
    setSelecteds(pathname)
  }else {
    setSelecteds(selected);
  }
    utils.routeJump1(props.history,selected[0])
  }
  let owerName = userInfo.owner;
  let domainName = userInfo.domain;
  let owerNamePrefix = "";
  if (owerName) {
    let nameArray = owerName.split(" ");
    for (let i = 0; i < nameArray.length; i++) {
      owerNamePrefix += nameArray[i].charAt(0);
    }
  } else {
    owerName = "Admin";
    owerNamePrefix = "A";
  }
  return (
    <nav>
      <Card padding={0} roundedAbove="xs">
        <Box style={{padding:'12px',background:'rgba(243, 243, 243, 1)'}}>
          <InlineStack gap={200} blockAlign='center'>
            <Box><Avatar initials={owerNamePrefix} name={owerName} /></Box>
            <Box>
              <Box></Box>
              <Box>
              <Text variant="headingMd" as="h6">
                {owerName}
              </Text>
              <Text variant="bodySm" as="p">
                {domainName}
              </Text>
              </Box>
            </Box>
          </InlineStack>
        </Box>
        <Box style={{padding:'5px 6px'}}>
          <OptionList
          title=""
          onChange={onChangeSelected}
          options={listArray}
          selected={selecteds}
        />
        </Box>
      </Card>
    </nav>
  );

}

export default connect()(withRouter(PageContent))